import { combineReducers } from 'redux'
import accessibility from './accessibility'
import applicationProcess from './applicationProcess'
import applicationWelcomeAlert from './applicationWelcomeAlert'
import authentication from './authentication'
import mail from './mail'
import userAccount from './userAccount'
import authorization from './authorization'
import claims from './claims'
import resource from './resource'
import newsUpdates from './newsUpdate'
import serviceType from './serviceType'
import location from './location'
import targetGroup from './targetGroup'
import transportation from './transportation'
import language from './language'
import overnightCare from './overnightCare'
import providerApplication from './providerApplication'
import locationApplication from './locationApplication'
import providerDetail from './providerDetail'
import providerFileAudit from './providerFileAudit'
import providerService from './providerService'
import staffingModel from './staffingModel'
import wavierCompliant from './wavierCompliant'
import carePlan from './carePlan'
import backgroundCheckVerification from './backgroundCheckVerification'
import ethnicity from './ethnicity'
import race from './race'
import RootState from '../../types/RootState'
import Action from '../../types/Action'

const allReducers = combineReducers({
  accessibility,
  applicationProcess,
  applicationWelcomeAlert,
  authentication, 
  authorization,
  backgroundCheckVerification,
  carePlan,
  claims,
  language,
  location,
  mail,
  newsUpdates,
  providerDetail,
  providerFileAudit,
  providerService,
  overnightCare,
  resource,
  serviceType,
  staffingModel,
  targetGroup,
  transportation,
  providerApplication,
  locationApplication,
  userAccount,
  wavierCompliant,
  ethnicity,
  race,
})

const rootReducer = (state: any, action: Action): RootState => {
  if (action.type === 'UNAUTH_USER') {
    state = undefined
  }

  return allReducers(state, action)
}

export default rootReducer
